import { render, staticRenderFns } from "./Omega.vue?vue&type=template&id=0b07f556&scoped=true&"
import script from "./Omega.vue?vue&type=script&lang=js&"
export * from "./Omega.vue?vue&type=script&lang=js&"
import style0 from "./Omega.vue?vue&type=style&index=0&id=0b07f556&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b07f556",
  null
  
)

export default component.exports